import { useTranslation } from "react-i18next"
import { Divider, Stack, Typography } from "@mui/material"

import type { EntityType } from "types/common.types"
import EntityIcon from "widgets/common/EntityIcon"
import { ENTITY_VISUALS } from "helpers/config/entityVisuals"

interface BaseTagProps {
  color: string
  lightColor: string
  icon: JSX.Element
  label: string
}

const BaseTag = ({ color, lightColor, icon, label }: BaseTagProps) => {
  return (
    <Stack
      width={"fit-content"}
      direction="row"
      justifyContent={"center"}
      alignItems={"center"}
      bgcolor={lightColor}
      border={1}
      borderColor={color}
      borderRadius={"5px"}
    >
      <Stack p={0.5} justifyContent={"center"} alignItems={"center"}>
        {icon}
      </Stack>
      <Divider orientation="vertical" flexItem sx={{ borderColor: color }} />
      <Typography py={0.5} px={1}>
        {label}
      </Typography>
    </Stack>
  )
}

interface EntityTagProps {
  entity: EntityType
}

const EntityTag = ({ entity }: EntityTagProps) => {
  const { t } = useTranslation()
  const visual = ENTITY_VISUALS[entity]

  return (
    <BaseTag
      color={visual.colorPath}
      lightColor={visual.lightPath}
      icon={<EntityIcon entity={entity} />}
      label={t(`entities.${entity.toUpperCase()}`)}
    />
  )
}

export default EntityTag
